/* ══════════════════════════════════════════════════════════════
   Event Timeline — Upcoming Events with Market Impact
   ══════════════════════════════════════════════════════════════ */

export interface TimelineEvent {
    date: string;
    time: string;
    title: string;
    category: string;
    impact: 'high' | 'medium' | 'low';
    description: string;
    historicalImpact?: string;
}

export function renderEventTimeline(container: HTMLElement, events?: TimelineEvent[]): void {
    const data: TimelineEvent[] = events || [
        { date: 'Today', time: '3:30 PM', title: 'Bajaj Finance Q3 Results', category: 'earnings', impact: 'high', description: 'Largest NBFC reports — watch NIM and asset quality', historicalImpact: 'Q2: +3.2% on beat' },
        { date: 'Today', time: '5:30 PM', title: 'India CPI Data', category: 'macro', impact: 'high', description: 'January inflation — consensus 5.1%', historicalImpact: 'Last: 5.22% → Nifty -0.5%' },
        { date: 'Tomorrow', time: '9:15 AM', title: 'Weekly Options Expiry', category: 'markets', impact: 'medium', description: 'Max pain at 23,050 — elevated volatility expected' },
        { date: 'Mar 3', time: 'All Day', title: 'RBI Policy Minutes Release', category: 'policy', impact: 'high', description: 'Detailed minutes from Feb meeting' },
        { date: 'Mar 5', time: '5:30 PM', title: 'India GDP Q3 FY26', category: 'macro', impact: 'high', description: 'Advance estimate: 6.5% consensus', historicalImpact: 'Q2: +0.8% on beat' },
        { date: 'Mar 10', time: '10:00 AM', title: 'SEBI Board Meeting', category: 'policy', impact: 'medium', description: 'New F&O regulations expected' },
    ];

    const impactIcon = { high: '🔴', medium: '🟡', low: '🟢' };

    const items = data.map((e, i) => `
    <div class="timeline-item" style="animation-delay: ${i * 0.05}s">
      <div class="timeline-dot ${e.impact}"></div>
      <div class="timeline-content glass-card">
        <div class="timeline-header">
          <span class="timeline-date">${e.date} ${e.time}</span>
          <span class="timeline-impact">${impactIcon[e.impact]} ${e.impact}</span>
        </div>
        <h4 class="timeline-title">${e.title}</h4>
        <p class="timeline-desc">${e.description}</p>
        ${e.historicalImpact ? `<small class="timeline-history">📊 Historical: ${e.historicalImpact}</small>` : ''}
      </div>
    </div>`).join('');

    container.innerHTML = `
    <div class="event-timeline">
      <h3>📅 Upcoming Events</h3>
      <div class="timeline-list">${items}</div>
    </div>`;
}
